module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YBzqzd/images/cover.jpg?1737196286178",
      "alt": "This image is the cover for the book Nothing Left to Fear from Hell"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nothing Left to Fear from Hell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A battle lost. A daring escape. A long walk into obscurity. The ultimate failure… In the aftermath of the disastrous Battle of Culloden, a lonely figure takes flight with a small band of companions through the islands and mountains of the Hebrides. His name is Charles Edward Stuart: better known today as Bonnie Prince Charlie. He had come to the country to take the throne. Now he is leaving in exile and abject defeat. In prose that is by turns poetic, comic, macabre, haunting and humane, multi- award-winning author Alan Warner traces the frantic last journey through Scotland of a man who history will come to define for his failure. 'Written in carefully crafted prose shot through with cleverly-deployed alliteration and assonance, this reimagining of Charles Edward Stuart’s escape from Culloden is a triumph' – Stuart Kelly, The Scotsman")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alan Warner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Polygon\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0